<template>
  <section class="drop-wrapper">
    <!-- 商品退费 -->
    <account-nav
      :type="'text'"
      :tabValue="'申请退课'"
      :slipper="false"
    ></account-nav>
    <div class="drop-loading">
      <div
        class="drop-content"
        v-show="ajaxStatus != -1"
      >
        <div
          class="drop-remarks"
          v-if="dropData.warning"
        >
          <p class="drop-title">退课须知:</p>
          <div class="drop-hint">
            <span class="hint-text">
              <!-- 退费规则明细 -->
              <el-popover
                popper-class="chapter-popover"
                placement="bottom"
                width="362"
                trigger="hover"
              >
                <span
                  slot="reference"
                  v-if="dropData.agreement.length > 0"
                  style="cursor: pointer"
                >
                  <img
                    class="real-price-img rule-icon-img"
                    src="../assets/img/rule-icon.png"
                    alt=""
                  >
                  更多退费规则
                </span>
                <div class="el-popover__title">
                  退费规则
                </div>
                <div class="real-content">
                  <div
                    v-for="(item, index) in dropData.agreement"
                    :key="index"
                  >
                    <p class="title">{{item.agreementTitle}}</p>
                    <ul>
                      <li
                        v-for="(list, index) in item.agreementInfo"
                        :key="index"
                      >{{list}}</li>
                    </ul>
                  </div>
                </div>
              </el-popover>
            </span>
            <ul>
              <li
                v-for="(item, index) in dropData.warning"
                :key="index"
              >
                {{item}}
              </li>
            </ul>
          </div>
        </div>
        <div v-if="dropData.productInfo">
          <p class="drop-title">商品信息</p>
          <table
            class="drop-table"
            width="100%"
          >
            <thead class="drop-table-thead">
              <tr class="drop-table-thead-tr">
                <th
                  class="drop-table-thead-tr-th"
                  width="30%"
                >商品信息</th>
                <th
                  class="drop-table-thead-tr-th"
                  width="15%"
                >实付款</th>
                <th
                  class="drop-table-thead-tr-th"
                  width="10%"
                  v-if="showCoupon"
                >扣除优惠券优惠</th>
                <th
                  class="drop-table-thead-tr-th"
                  width="10%"
                  v-if="showSubjects"
                >多科优惠</th>
                <th
                  class="drop-table-thead-tr-th"
                  width="10%"
                  v-if="showFull"
                >满减优惠扣除</th>
                <th
                  class="drop-table-thead-tr-th"
                  width="10%"
                >课时费</th>
                <th
                  class="drop-table-thead-tr-th"
                  width="10%"
                >讲义工本费</th>
                <th
                  class="drop-table-thead-tr-th"
                  width="15%"
                >应退金额</th>
              </tr>
            </thead>
            <tbody class="drop-table-tbody">
              <tr
                class="drop-table-tbody-tr"
                v-for="(item, index) in dropData.productInfo"
                :key="index"
              >
                <!-- 商品信息 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="30%"
                >
                  <!-- 换购icon -->
                  <span
                    class="exchange-icon"
                    v-if="item.productTag && item.productTag != ''"
                  >{{item.productTag}}</span>
                  <!-- 学科icon -->
                  <span
                    class="xue-am-badge"
                    v-show="item.subjectName"
                  >{{item.subjectName}}</span>
                  <span class="course-name">{{item.productName}}</span>
                  <!-- 对课程所做的处理 -->
                  <p
                    class="course-date"
                    v-if="dropData.productType != 230 && item.showName"
                  >上课时间：{{item.showName}}</p>
                  <p
                    class="course-date"
                    v-if="dropData.productType == 230 && item.showName"
                  >{{item.showName}}</p>
                  <p class="course-teacher">
                    <span
                      v-if="item.teacherInfos.length > 0"
                      class="teacher-infos"
                    >
                      <span>授课：</span>
                      <span
                        v-for="(teacher, index1) in item.teacherInfos"
                        :key="index1"
                        style="margin-right: 10px"
                      >
                        <em>{{teacher.teacherName}}</em>
                      </span>
                    </span>
                    <span
                      v-if="item.foreignInfos && item.foreignInfos.length > 0"
                      class="counse-infos"
                    >
                      <span>外教：</span>
                      <span
                        v-for="(foreign, index2) in item.foreignInfos"
                        :key="index2"
                        style="margin-right: 10px"
                      >
                        <em>{{foreign.teacherName}}</em>
                      </span>
                    </span>
                  </p>
                </td>
                <!-- 实付款 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="15%"
                >
                  <div class="td-vertical">
                    ￥{{item.priceDetail.realPrice}}
                    <el-popover
                      popper-class="chapter-popover"
                      placement="bottom"
                      width="362"
                      trigger="hover"
                    >
                      <span
                        slot="reference"
                        v-if="item.priceDetail.promotionInfos.length > 0"
                      >
                        <img
                          class="real-price-img"
                          src="../assets/img/icon_xinxi.png"
                          alt=""
                        >
                      </span>
                      <div class="el-popover__title">
                        实付款明细
                      </div>
                      <div class="real-content">
                        <div class="real-item">
                          <div class="real-left">
                            <span>商品金额</span>
                          </div>
                          <div class="real-right">
                            <span v-show="item.priceDetail.productPrice">￥{{item.priceDetail.productPrice}}</span>
                          </div>
                        </div>
                        <div
                          class="real-item"
                          v-for="(real, index) in item.priceDetail.promotionInfos"
                          :key="index"
                        >
                          <div class="real-left">
                            <span>{{real.promotionName}}</span>
                          </div>
                          <div class="real-right">
                            <span>-￥{{real.promotionPrice}}</span>
                          </div>
                        </div>
                        <div class="real-item">
                          <div class="real-left">
                            <span>实付款</span>
                          </div>
                          <div class="real-right">
                            <span class="red">￥{{item.priceDetail.realPrice}}</span>
                          </div>
                        </div>
                      </div>
                    </el-popover>
                    <br />
                    <span v-if="Number(item.priceDetail.prepaidCardPrice)">￥{{item.priceDetail.prepaidCardPrice}}（礼品卡）</span>
                  </div>
                </td>
                <!-- 订单券优惠防套利-扣除优惠券优惠 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="10%"
                  v-if="showCoupon"
                >
                  <div
                    class="td-vertical"
                    v-if="item.orderCouponDeduct"
                  >
                    -￥{{item.orderCouponDeduct.price}}
                    <el-popover
                      popper-class="chapter-popover"
                      placement="bottom"
                      width="362"
                      trigger="hover"
                    >
                      <span
                        slot="reference"
                        v-if="item.priceDetail.promotionInfos.length > 0"
                      >
                        <img
                          class="real-price-img"
                          src="../assets/img/icon_xinxi.png"
                          alt=""
                        >
                      </span>
                      <div class="el-popover__title">
                        {{item.orderCouponDeduct.title}}
                      </div>
                      <hr class="popover-common-hr" />
                      <div class="order-container">
                        <div class="order-title-one">
                          <span>{{item.orderCouponDeduct.subTitle}}</span>
                          <span>-￥{{item.orderCouponDeduct.price}}</span>
                        </div>
                        <div class="order-title-desc">
                          {{item.orderCouponDeduct.desc}}
                        </div>
                        <div class="order-content">
                          <div
                            class="order-item"
                            v-for="(detail, index) in item.orderCouponDeduct.detail"
                            :key="index"
                          >
                            <div class="order-item-left">
                              <span class="order-item-title-tag">{{detail.subject}}</span>
                              {{detail.name}}
                            </div>
                            <div class="order-item-right">-￥{{detail.price}}</div>
                          </div>
                        </div>
                      </div>
                    </el-popover>
                    <br />
                    <!--                    <span v-if="Number(item.priceDetail.prepaidCardPrice)">￥{{item.priceDetail.prepaidCardPrice}}（礼品卡）</span>-->
                  </div>
                </td>
                <!-- 多科优惠 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="10%"
                  v-if="showSubjects"
                >
                  <div class="class-pay">
                    <p v-if="item.additionalOrderDeduct">
                      -￥{{item.additionalOrderDeduct.price}}
                      <el-popover
                        popper-class="chapter-popover"
                        placement="bottom"
                        width="382"
                        trigger="hover"
                      >
                        <span
                          slot="reference"
                          v-if="item.additionalOrderDeduct.detail.length > 0"
                        >
                          <img
                            style="cursor: pointer"
                            src="../assets/img/icon_xinxi.png"
                            alt=""
                          >
                        </span>
                        <div class="el-popover__title">
                          {{item.additionalOrderDeduct.title}}
                        </div>
                        <hr class="popover-common-hr" />
                        <div class="subjects-container">
                          <div class="subjects-title-one">{{item.additionalOrderDeduct.subTitleOne}}</div>
                          <div class="subjects-title-desc">
                            {{item.additionalOrderDeduct.desc}}
                          </div>
                          <div class="subjects-price">
                            <span class="subjects-price-title">{{item.additionalOrderDeduct.subTitleTwo}}</span>
                            <span class="subjects-price-num">-￥{{item.additionalOrderDeduct.price}}</span>
                          </div>
                          <div class="subjects-content">
                            <div
                              class="subjects-item"
                              v-for="(detail, index) in item.additionalOrderDeduct.detail"
                              :key="index"
                            >
                              <p class="subjects-item-title">{{detail.title}}</p>
                              <div
                                class="subjects-item-course"
                                v-for="(course, cindex) in detail.courseList"
                                :key="cindex"
                              >
                                <div class="subjects-item-left">
                                  {{course.name}}
                                </div>
                                <div class="subjects-item-right">
                                  -￥{{course.price}}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </p>
                    <p v-if="!item.additionalOrderDeduct">0</p>
                  </div>
                </td>
                <!-- 满减优惠扣除 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="10%"
                  v-if="showFull"
                >
                  <div class="class-pay">
                    <p v-if="item.fullPriceOffInfo">
                      -￥{{item.fullPriceOffInfo.totalPrice}}
                      <el-popover
                        popper-class="chapter-popover"
                        placement="bottom"
                        width="362"
                        trigger="hover"
                      >
                        <span
                          slot="reference"
                          v-if="item.fullPriceOffInfo.detail.length > 0"
                        >
                          <img
                            style="cursor: pointer"
                            src="../assets/img/icon_xinxi.png"
                            alt=""
                          >
                        </span>
                        <div class="el-popover__title">
                          {{item.fullPriceOffInfo.title}}
                        </div>
                        <div class="full-text">
                          {{item.fullPriceOffInfo.desc}}
                        </div>
                        <div class="reduce-content">
                          <div
                            class="reduce-item"
                            v-for="(detail, index) in item.fullPriceOffInfo.detail"
                            :key="index"
                          >
                            <div class="detail-left">
                              <p>
                                <span class="chapter-detail">
                                  <span
                                    class="rule-icon"
                                    v-show="detail.promotionName"
                                  >{{detail.promotionName}}</span>
                                  <span
                                    class="xue-am-badge"
                                    v-show="detail.subjectName"
                                  >{{detail.subjectName}}</span>
                                  <span v-show="detail.productName">{{detail.productName}}</span>
                                </span>
                              </p>
                            </div>
                            <div class="detail-right">
                              <span v-show="detail.promotionPrice||detail.promotionPrice===0">￥{{detail.promotionPrice}}</span>
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </p>
                    <p v-if="!item.fullPriceOffInfo">0</p>
                  </div>
                </td>
                <!-- 课时费 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="10%"
                >
                  <div class="class-pay">
                    <p>
                      -￥{{item.chapterInfo.chapterTotalPrice}}
                      <el-popover
                        popper-class="chapter-popover"
                        placement="bottom"
                        width="362"
                        trigger="hover"
                      >
                        <span
                          slot="reference"
                          v-if="item.chapterInfo.chapterDetail.length > 0"
                        >
                          <img
                            style="cursor: pointer"
                            src="../assets/img/icon_xinxi.png"
                            alt=""
                          >
                        </span>
                        <div class="el-popover__title">
                          课时费明细
                          <span class="hasLearn">(已学场次<span class="red">{{item.chapterInfo.learnCnt}}</span>/{{item.chapterInfo.totalCnt}})</span>
                        </div>
                        <div class="chapter-content">
                          <div
                            class="chapter-item"
                            v-if="Number(item.chapterInfo.deductedPrepaidCardPrice)"
                          >
                            <div class="detail-left">
                              <p>
                                <span class="chapter-detail">
                                  <span>已学讲次减扣礼品卡</span>
                                </span>
                              </p>
                            </div>
                            <div class="detail-right">
                              <span>￥{{item.chapterInfo.deductedPrepaidCardPrice}}</span>
                            </div>
                          </div>
                          <div
                            class="chapter-item"
                            v-for="(detail, index) in item.chapterInfo.chapterDetail"
                            :key="index"
                          >
                            <div class="detail-left">
                              <p>
                                <span class="chapter-detail">
                                  <span
                                    class="xue-am-badge"
                                    v-show="detail.chapterTag"
                                  >{{detail.chapterTag}}</span>
                                  <span v-show="detail.chapterName">{{detail.chapterName}}</span>
                                </span>
                              </p>
                              <p
                                class="chapter-time"
                                v-show="detail.chapterTime"
                              >{{detail.chapterTime}}</p>
                            </div>
                            <div class="detail-right">
                              <span v-show="detail.chapterPrice">￥{{detail.chapterPrice}}</span>
                            </div>
                          </div>
                        </div>
                      </el-popover>
                    </p>
                    <p class="course-date">{{`(已学${item.chapterInfo.learnCnt}/${item.chapterInfo.totalCnt}场)`}}</p>
                  </div>
                </td>
                <!-- 讲义工本费 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="10%"
                >
                  <div class="td-vertical">-￥{{item.gongbenfei}}
                    <el-popover
                      popper-class="chapter-popover"
                      placement="bottom"
                      width="362"
                      trigger="hover"
                    >
                      <span
                        slot="reference"
                        v-if="item.goodsDetail.length > 0"
                      >
                        <img
                          style="vertical-align: top; cursor: pointer"
                          src="../assets/img/icon_xinxi.png"
                          alt=""
                        >
                      </span>
                      <div class="el-popover__title">讲义工本费</div>
                      <div class="teach-content">
                        <div
                          class="teach-item"
                          v-for="(detail, index) in item.goodsDetail"
                          :key="index"
                        >
                          <div class="detail-left">
                            <p><span v-show="detail.goodsName">{{detail.goodsName}}</span></p>
                          </div>
                          <div class="detail-right">
                            <span v-show="detail.goodsPrice != 0 || detail.goodsPrice != ''">￥{{detail.goodsPrice}}</span>
                          </div>
                        </div>
                      </div>
                    </el-popover>
                  </div>
                </td>
                <!-- 应退金额 -->
                <td
                  class="drop-table-tbody-tr-td"
                  width="15%"
                >
                  <span class="td-vertical td-return-price">￥{{item.returnPrice}}</span>
                  <div
                    class="td-vertical td-return-price"
                    v-if="Number(item.returnPrepaidCardPrice)"
                  >￥{{item.returnPrepaidCardPrice}}<span style="color: #666;">（礼品卡）</span></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="dropData.returnReason">
          <p class="drop-title">退课原因<span class="special-tip">（必填）</span></p>
          <div class="drop-reason">
            <div
              class="drop-reason-content"
              v-for="(drop, index) in dropData.returnReason"
              :key="index"
            >
              <span class="reason-class">{{drop.reasonTitle}}</span>
              <el-checkbox-group v-model="checkedReason">
                <el-checkbox
                  v-for="item in drop.reasonInfo"
                  :key="item.reasonDesc"
                  :label="item.reasonId"
                >
                  {{item.reasonDesc}}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div v-if="ajaxStatus">
          <p class="drop-title">意见反馈<span class="special-tip">（选填）</span></p>
          <div class="drop-advise">
            <textarea
              v-model="advises"
              name="advise"
              id="advises"
              cols="30"
              rows="4"
              placeholder="快把您的建议或意见反馈给我们吧～"
            ></textarea>
          </div>
          <!-- 增加退费协议 -->
          <!-- 增加不能退费，防套利击穿，联系客服 -->
          <div
            class="drop-contact"
            v-if="dropData.customer"
          >
            <div class="drop-contact-txt">{{ dropData.customer.tips }}&nbsp;</div>
            <a
              href="javascript:void(0);"
              class="drop-contact-btn"
              @click="viewContact(dropData.customer.link)"
            >{{ dropData.customer.alt }}</a>
          </div>
          <div
            class="drop-agreement"
            v-else
          >
            <el-checkbox v-model="checkedAggrement">我已阅读并同意</el-checkbox>
            <a @click="viewAgreement">《退费协议》</a>
          </div>
          <div class="drop-submit">
            <button
              class="drop-submit-btn"
              :class="dropData.opInfo && dropData.opInfo.canOp != 0 ? 'active' : '' "
              @click="dropSubmit"
            >{{buttonTxt}}</button>
          </div>
        </div>
        <!-- 错误提示框 -->
        <account-model
          v-show="showModel"
          :modelStyles="{'width': '320px'}"
          :titleStyles="{'height': '40px', 'lineHeight': '40px'}"
          :hasFooter="false"
          :content="warning"
          @closeModel="closeModel"
        ></account-model>
      </div>
      <error
        v-if="!ajaxStatus"
        :warning="warning"
        :mainStyles="{'margin-top': '15%','height': '100%'}"
      ></error>
    </div>
    <!-- 退费提交结果弹框 stuCouIds要遍历dropData.productInfo获取stuProductId -->
    <iframe
      v-if="dropPriceSuccess != -1"
      :src="`${dropPriceUrl}orderNum=${dropData.orderNum}&stuCouIds=${(dropData.productInfo || []).map(item => item.stuProductId).join()}`"
      class="order-drop-price-dialog"
    ></iframe>
    <!-- <drop-price-dialog  v-show="dropPriceSuccess != -1  && checkedReason.length > 0 && stuProductIds.length > 0"
      @closeDropPhoneDialog="closeDropPhoneDialog"
      @showDropDiolag="showDropDiolag"
      :advises="advises"
      :stuProductIds="stuProductIds"
      :productType="productType"
      :checkedReason="checkedReason"
      :dropDialog="dropDialog"
    >
    </drop-price-dialog> -->
    <!-- 退费挽留和直接退费结果弹框 -->
    <drop-Dialog
      v-show="dropSuccess != -1"
      :dropSuccess="dropSuccess"
      @closeDropDialog="closeDropDialog"
    ></drop-Dialog>

    <!-- 退费异常提示弹框 -->
    <accountModel
      v-show="showReFundModel"
      :modelStyles="{'width': '446px'}"
      :hasFooter="false"
      :notShowGray="true"
      @closeModel="closeReFundModel"
    >
      <div
        class="cancel-refund-header"
        slot="header"
      >
        <em
          class="el-icon-close"
          @click='closeReFundModel'
        ></em>
      </div>
      <div
        class="drop-cancel-wrapper"
        slot="content"
      >
        <p class="cancel-text">{{cancelRefundTxt}}</p>
        <div
          class="reduce-product-info"
          v-if="this.reduceProductInfos"
        >
          <div
            class="reduce-product-item"
            v-for="(item, index) in this.reduceProductInfos"
            :key="index"
          >
            <span>{{item.productName}}</span>
          </div>
        </div>
        <div
          class="cancel-footer-unnormal"
          v-if="this.operateInfo && this.operateInfo.length > 0"
        >
          <span
            v-for="(item, index) in this.operateInfo"
            :key="index"
          >
            <button
              :class="index === 0 ? 'cancel-btn' : 'confirm-btn'"
              @click="operateClick(item.status)"
            >{{item.statusDesc}}</button>
          </span>
        </div>
      </div>
    </accountModel>

    <!-- 仍要退费弹框 -->
    <accountModel
      v-show="isShowGoPay"
      :modelStyles="{'width': '446px', 'height': '258px'}"
      :hasFooter="false"
      :notShowGray="true"
      @closeModel="closeGoRefund"
    >
      <div
        class="cancel-refund-header"
        slot="header"
      >
        <em
          class="el-icon-close"
          @click='closeGoRefund'
        ></em>
      </div>
      <div
        class="drop-cancel-wrapper"
        slot="content"
      >
        <p class="go-refund-title">仍要退课吗？</p>
        <p class="go-refund-txt">退课后，若该课程名额已报满，将无法重购</p>
        <div class="cancel-footer">
          <button
            class="cancel-btn"
            @click="closeGoRefund"
          >取消</button>
          <button
            class="confirm-btn"
            @click="goRefund"
          >仍要退课</button>
        </div>
      </div>
    </accountModel>

    <!-- 退费协议弹框 -->
    <refundAgreement
      v-show="showRefundAgreement"
      :agreement="this.dropData.agreement"
      :showRefundAgreement="showRefundAgreement"
      @closeRefundAgreement="closeRefundAgreement"
    ></refundAgreement>
  </section>
</template>

<script>
import axios from '~common/assets/js/ocenter-axios.js'
import { Loading } from 'element-ui'
import accountNav from '@/components/sub/accountNav.vue'
import accountModel from '@/components/sub/accountModel.vue'
import error from '@/components/sub/error.vue'
import qrcodeDialog from '@/components/dialog/qrcodeDialog.vue'
import dropDialog from '@/components/dialog/dropDialog.vue'
import dropPriceDialog from '@/components/dialog/dropPriceDialog.vue'
import refundAgreement from '@/components/dialog/refundAgreement.vue'
import config from '../config'

export default {
  name: 'account',
  metaInfo: {
    title: '我的订单-申请退课'
  },
  components: {
    accountNav,
    accountModel,
    error,
    qrcodeDialog,
    dropDialog,
    dropPriceDialog,
    refundAgreement
  },
  data () {
    return {
      dropData: {}, // 退费-接口请求回来的数据
      showModel: false,
      warning: '请求失败，请重试......',
      checkedReason: [], // 退费原因
      advises: '', // 网校建议
      ajaxStatus: -1, // 页面信息接口请求状态；-1 未请求，1-成功，0-失败
      dropSuccess: -1, // 是否退费成功；-1 未请求，1-成功，0-失败
      dropPriceSuccess: -1, // -1表示未验证手机号 1-表示成功
      dropPriceUrl: 'https://app.xueersi.com/refund-result?',
      loadFlag: false,
      loadingInstance: null,
      loadingTimer: null,
      stuProductIds: '',
      productType: '', // 商品类型
      checkedAggrement: '',
      showRefundAgreement: false,
      agreement: '',
      buttonTxt: '提交',
      dropDialog: {}, // 退费结果弹框展示信息
      showReFundModel: false,
      cancelRefundTxt: '',
      reduceProductInfos: [],
      cancelOperate: '1',
      operateInfo: [], // 退费结果弹框操作
      isShowGoPay: false, // 是否展示仍要退费弹框
      showSubjects: false, // 是否展示多科优惠
      showFull: false, // 是否展示满减优惠扣除文案
      showCoupon: false // 是否展示订单券优惠防套利-扣除优惠券优惠扣除文案
    }
  },
  computed: {
    count () {
      return `${this.advises.length}/100`
    }
  },
  watch: {
    loadFlag: function () {
      if (!this.loadFlag) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    }
  },
  mounted () {
    this.addListener()
    this.$nextTick(() => {
      this.loading('.drop-loading')
      this.getDetail()
    })
  },
  methods: {
    addListener () {
      document.domain = 'xueersi.com'
      window.addEventListener('message', (event) => {
        const type = event.data.type
        if (type == 'closeDialog') {
          // 关闭iframe
          this.closeDropPhoneDialog()
          this.$router.go(-1)
        }
      })
    },
    // 获取退费页信息
    getDetail () {
      axios.post(this.Service.Order.getReturnProductInfo, {
        productType: this.$route.query.productType ? this.$route.query.productType : 100,
        returnParams: this.$route.query.returnParams ? this.$route.query.returnParams : this.$route.query.stuCouId
      })
        .then((res) => {
          clearTimeout(this.loadingTimer)
          this.loadFlag = false
          if (res.status == 1) {
            this.ajaxStatus = 1
            this.dropData = res.data
            this.dropData.productInfo.map(item => {
              if (item.fullPriceOffInfo) {
                this.showFull = true
              }
              if (item.additionalOrderDeduct) {
                this.showSubjects = true
              }
              if (item.orderCouponDeduct) {
                this.showCoupon = true
              }
            })
            this.stuProductIds = res.data.stuProductId
            this.productType = res.data.productType
            if (this.dropData.opInfo && this.dropData.opInfo.canOp != 0) {
              this.buttonTxt = '提交'
            } else {
              this.buttonTxt = '退课金额为0，不可退课'
            }
          } else {
            this.warning = res.data
            this.ajaxStatus = 0
          }
        })
    },
    closeReFundModel () {
      this.showReFundModel = false
    },
    // 退费异常提示操作
    operateClick (status) {
      if (status == 4) {
        this.showReFundModel = false
        this.getDetail()
        this.checkedReason = [] // 退费原因
        this.advises = '' // 网校建议
        this.checkedAggrement = ''
      }
      if (status == 2) {
        this.showReFundModel = false
        this.getDetail()
        this.checkedReason = [] // 退费原因
        this.advises = '' // 网校建议
        this.checkedAggrement = ''
      }
      // 返回订单
      if (status == 5) {
        this.$router.go(-1)
      }
      // 联系客服
      if (status == 3) {
        this.showReFundModel = false
        if (this.$common && this.$common.CustomerService) {
          this.$common.CustomerService.show({
            key: config.QiYuKey
          })
        }
      }
    },
    // 退费提交按钮
    dropSubmit () {
      // opInfo.canOp为1的情况下可以提交，为0的情况不可以提交
      // 退费原因-其他原因中增加”重新购买“，选择包含该原因提交退费申请，不管是否有辅导/专属老师都不走挽留，其他原因走退费挽留
      if (this.dropData.opInfo && this.dropData.opInfo.canOp == 0) return
      if (this.checkedReason.length <= 0) {
        this.$message.warning('请选择退课原因')
        return
      }
      if (this.advises.length > 100) {
        this.warning = '对网校的建议不可以超过100个字哦～'
        this.showModel = true
        return
      }
      if (!this.checkedAggrement) {
        this.$message.warning('请阅读并同意《退费协议》')
        return
      }
      // 退费二次确认
      if (this.dropData.opInfo && this.dropData.opInfo.canOp == 1) {
        this.isShowGoPay = true
      }
    },
    closeGoRefund () {
      this.isShowGoPay = false
    },
    goRefund () {
      this.isShowGoPay = false

      axios.post('https://ocenter.xueersi.com/Web/SubmitRefund/index', {
        productType: this.productType,
        stuProductIds: this.stuProductIds,
        returnReasonId: this.checkedReason.join(','),
        suggestion: this.advises,
        returnParams: this.$route.query.returnParams ? this.$route.query.returnParams : this.$route.query.stuCouId
      }).then((res) => {
        if (res.status == 1) {
          // 正常退费成功
          if (res.data.status == 1) {
            // 将退费弹框信息传递出去
            this.dropDialog = res.data
            this.dropPriceSuccess = 1
          }
          // 异常提示弹框
          if (res.data.status == 10006) {
            this.showReFundModel = true
            this.cancelRefundTxt = res.data.msg
            this.operateInfo = res.data.operateInfo
            if (res.data.productInfos && res.data.productInfos.length > 0) {
              this.reduceProductInfos = res.data.productInfos
            }
          }
        } else {
          this.$message.error(res.data)
        }
      })
    },
    // 短信验证码确认退费成功后
    showDropDiolag (val) {
      this.closeDropPhoneDialog()
      this.dropSuccess = val
    },
    // 关闭退费成功与否的提示框
    closeDropDialog () {
      this.dropSuccess = -1
    },
    closeDropPhoneDialog () {
      this.dropPriceSuccess = -1
    },
    closeModel () {
      this.showModel = false
    },
    closeRefundAgreement () {
      this.showRefundAgreement = false
    },
    loading (selector) {
      let loadTime = 300
      this.loadingTimer = setTimeout(() => {
        this.loadFlag = true
        if (this.loadFlag) {
          this.loadingInstance = Loading.service({
            target: document.querySelector(selector),
            text: '拼命加载中',
            spinner: 'el-icon-loading',
            fullscreen: false,
            background: 'rgba(255, 255, 255, 0.8)',
            customClass: 'loading'
          })
        }
        clearTimeout(this.loadingTimer)
      }, loadTime)
    },
    viewAgreement () {
      this.showRefundAgreement = true
    },
    viewContact (link) {
      setTimeout(() => {
        link && window.open(link)
      }, 100)
      const params = {
        clickid: 'click_05_34_018',
        productType: this.$route.query.productType ? this.$route.query.productType : 100,
        returnParams: this.$route.query.returnParams ? this.$route.query.returnParams : this.$route.query.stuCouId
      }
      this.$xesLogger.clickMsg({
        params: params
      })
    }
  }
}
</script>

<style lang='less'>
.xue-am-badge {
  display: inline-block;
  min-width: 10px;
  padding: 1px;
  font-size: 12px;
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  border-radius: 2px;
  background-color: transparent;
  border: 1px solid #f13232;
  color: #f13232;
}
.drop-wrapper {
  font-size: 12px;
  .drop-loading {
    min-height: 500px;
  }
  .drop-content {
    padding: 0 20px;
    color: #666666;
    .drop-remarks {
      margin: 20px 0 0 0;
      font-size: 12px;
      .drop-title {
        font-size: 12px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
      }
      .hint-text {
        position: absolute;
        right: 10px;
        top: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(241, 50, 50, 1);
      }
      .drop-hint {
        position: relative;
        width: 960px;
        padding: 12px 16px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(224, 224, 224, 1);
        ul li {
          margin-bottom: 6px;
        }
      }
    }
    .drop-title {
      margin: 20px 0 10px 0;
      font-weight: bolder;
      font-size: 12px;
      clear: both;
    }
    .drop-table {
      border: solid 1px #eaeaea;
      border-spacing: 0;
      .drop-table-thead-tr {
        height: 46px;
      }
      .drop-table-thead-tr-th {
        font-weight: normal;
        text-align: center;
        &:first-child {
          padding-left: 20px;
        }
        &:last-child {
          padding-right: 20px;
        }
      }
      .drop-table-tbody-tr {
        vertical-align: top;
      }
      .drop-table-tbody-tr-td {
        border-top: solid 1px #eaeaea;
        padding: 20px 0;
        text-align: center;
        &:first-child {
          text-align: left;
          padding-left: 20px;
        }
        &:last-child {
          padding-right: 20px;
        }
      }
      .exchange-icon {
        background: #f0773c;
        line-height: 16px;
        font-size: 12px;
        color: #fff;
        border-radius: 2px;
        display: inline-block;
        padding: 0 4px;
        margin-right: 6px;
      }
      .course-name {
        font-size: 14px;
        color: #333;
      }
      .course-date {
        font-size: 12px;
        margin: 10px 0 0 0;
        color: #999;
        .course-time {
          margin-left: 5px;
        }
      }
      .course-teacher {
        font-size: 12px;
        margin: 5px 0 0 0;
        .teacher-infos {
          margin-right: 20px;
        }
      }
      .td-vertical {
        display: block;
        position: relative;
        top: 28px;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        color: rgba(102, 102, 102, 1);
        .real-price-img {
          vertical-align: bottom;
          cursor: pointer;
        }
      }
      .td-return-price {
        color: rgba(241, 50, 50, 1);
      }
      .class-pay {
        padding-top: 21px;
        img {
          vertical-align: text-top;
        }
      }
      .td-vertical-hints {
        min-width: 100%;
        position: absolute;
        top: 60%;
        left: 50%;
        -webkit-transform: translate(-50%, 0);
        -moz-transform: translate(-50%, 0);
        -ms-transform: translate(-50%, 0);
        transform: translate(-50%, 0);
        color: #f13232;
      }
    }
    .special-tip {
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
    .drop-reason {
      border: solid 1px #eaeaea;
      height: 126px;
      .drop-reason-content {
        border-bottom: 1px solid #eaeaea;
        height: 40px;
        &:last-child {
          border: 0;
        }
        .reason-class {
          padding: 17px 20px 13px 20px;
          border-right: 1px solid #e0e0e0;
        }
      }
      .el-checkbox-group {
        display: inline-block;
        .el-checkbox .el-checkbox__inner {
          margin-left: 17px;
        }
      }
    }
    .drop-advise {
      position: relative;
      #advises {
        height: 108px;
        width: 600px;
        padding: 10px 15px;
        outline: none;
        resize: none;
        font-size: 12px;
        border-color: #eaeaea;
        color: #666666;
      }
      #advises::-webkit-input-placeholder {
        color: #989696 !important;
      }
      #advises:-moz-placeholder {
        color: #989696 !important;
      }
      #advises::-moz-placeholder {
        color: #989696 !important;
      }
      #advises:-ms-input-placeholder {
        color: #989696 !important;
      }
      .count {
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }
    .drop-contact {
      margin-top: 26px;
      padding: 12px 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #000;
      background-color: #ffeeed;
      font-size: 14px;
      .drop-contact-btn {
        color: #e02727;
        font-weight: 600;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .drop-agreement {
      a {
        font-size: 12px;
        font-weight: 300;
        font-family: PingFangSC-Light;
        color: #ff5e50;
        cursor: pointer;
      }
      .el-checkbox {
        margin-top: 26px;
        margin-right: 0;
        .el-checkbox__label {
          color: #858c96;
          font-size: 12px;
        }
        .el-checkbox__inner {
          width: 12px;
          height: 12px;
          border-radius: 100%;
          border-color: #bbbbbb;
          &:after {
            height: 6px;
            left: 3px;
          }
          &:hover {
            border-color: #f13232;
          }
        }
      }
      .is-focus {
        .el-checkbox__inner {
          border-color: #bbbbbb;
        }
      }
      .is-checked {
        .el-checkbox__inner {
          background-color: #f13232;
          border-color: #f13232;
        }
        .el-checkbox__label {
          color: #f13232;
        }
      }
    }
    .drop-submit {
      margin: 20px 20px 20px 0px;
      font-size: 0;
      .drop-submit-btn {
        background: rgba(220, 220, 220, 1);
        border-radius: 2px;
        border: none;
        width: 188px;
        height: 40px;
        line-height: 30px;
        border-radius: 2px;
        font-size: 14px;
        background: rgba(220, 220, 220, 1);
        color: #ffffff;
        cursor: default;
      }
      .in-return-tips {
        font-size: 12px;
        margin-left: 20px;
        color: #f13232;
      }
      .active {
        width: 130px;
        background: #f13232;
        cursor: pointer;
      }
    }
    .drop-reason {
      .el-checkbox-group {
        .el-checkbox + .el-checkbox {
          margin-left: 0;
        }
        .el-checkbox {
          width: 160px;
          margin-top: 15px;
          .el-checkbox__inner {
            width: 12px;
            height: 12px;
            border-color: #bbbbbb;
            &:after {
              height: 6px;
              left: 3px;
            }
            &:hover {
              border-color: #f13232;
            }
          }
          .el-checkbox__label {
            min-width: 76px;
            padding-left: 8px;
            font-size: 12px;
          }
        }
        .is-focus {
          .el-checkbox__inner {
            border-color: #bbbbbb;
          }
        }
        .is-checked {
          .el-checkbox__inner {
            background-color: #f13232;
            border-color: #f13232;
          }
          .el-checkbox__label {
            color: #606266;
          }
        }
      }
    }
  }
}
// popover弹出框
.chapter-popover {
  padding: 20px;
  max-height: 244px;
  .el-popover__title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    width: 322px;
    margin-bottom: 0;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    .hasLearn {
      margin-left: 16px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      .red {
        color: #f13232;
      }
    }
  }
  .popover-common-hr {
    margin: 10px 0;
  }
  .subjects-container {
    font-size: 12px;
    color: #333;
    overflow-y: auto;
    height: 150px;
    font-weight: 400;
    .subjects-title-one {
      font-size: 15px;
      font-weight: 500;
    }
    .subjects-title-desc {
      margin-top: 10px;
    }
    .subjects-price {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 10px;
      font-size: 15px;
      font-weight: 500;
      .subjects-price-title {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .subjects-price-num {
        font-size: 14px;
        color: #ff0000;
      }
    }
    .subjects-item-title {
      margin: 10px 0;
    }
    .subjects-item-course {
      background-color: #f3f3f3;
      padding: 10px;
    }
    .subjects-item-course {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .subjects-item-left {
      max-width: 240px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  .order-container {
    font-size: 12px;
    color: #333;
    overflow-y: auto;
    font-weight: 400;
    height: 170px;
    .order-title-one {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 15px;
      font-weight: 500;
    }
    .order-title-desc {
      margin-top: 10px;
    }
    .order-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
    }
    .order-item-left {
      max-width: 240px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      .order-item-title-tag {
        border: 1px;
        display: inline-block;
        min-width: 10px;
        padding: 1px;
        font-size: 12px;
        line-height: 1;
        vertical-align: baseline;
        white-space: nowrap;
        text-align: center;
        border-radius: 2px;
        background-color: transparent;
        border: 1px solid #f13232;
        color: #f13232;
      }
    }
  }
  .full-text {
    font-size: 11px;
    font-weight: 400;
    color: rgba(241, 50, 50, 1);
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(245, 245, 245, 1);
  }
  .reduce-content {
    max-height: 120px;
    overflow: auto;
    .detail-left {
      float: left;
    }
    .detail-right {
      float: right;
    }
    .reduce-item {
      clear: both;
      padding-top: 20px;
      &:first-child {
        padding-top: 0;
      }
      .detail-left {
        width: 260px;
        float: left;
        .chapter-detail {
          max-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
          -webkit-line-clamp: 2;
          word-wrap: break-word;
        }
        margin-bottom: 10px;
        .chapter-time {
          margin-top: 6px;
          color: #999;
        }
      }
      .detail-right {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
        float: right;
      }
    }
  }
  .real-content {
    max-height: 170px;
    line-height: 25px;
    overflow: auto;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    padding-top: 15px;
    border-top: 1px solid rgba(245, 245, 245, 1);
    padding-left: 10px;
    padding-right: 20px;
    padding-bottom: 20px;
    .real-item {
      clear: both;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
      .real-left {
        float: left;
      }
      .real-right {
        float: right;
      }
      .red {
        font-weight: 500;
        color: rgba(241, 50, 50, 1);
      }
    }
  }
  // 课时费明细
  .chapter-content {
    max-height: 170px;
    overflow: auto;
    .chapter-item {
      height: 32px;
      margin-top: 15px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      &:first-child {
        margin-top: 20px;
      }
      .detail-left {
        width: 270px;
        float: left;
        .chapter-detail {
          max-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box; //将对象作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
          -webkit-line-clamp: 2;
          word-wrap: break-word;
        }
        margin-bottom: 10px;
        .chapter-time {
          margin-top: 6px;
          color: #999;
        }
      }
      .detail-right {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(102, 102, 102, 1);
        float: right;
      }
    }
  }
  // 讲义工本费明细
  .teach-content {
    max-height: 160px;
    overflow: auto;
    font-size: 12px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    .teach-item {
      .detail-left {
        float: left;
        width: 285px;
        padding-top: 20px;
        .chapter-time {
          margin-top: 6px;
          color: #999;
        }
      }
      .detail-right {
        float: right;
        padding-top: 20px;
      }
    }
  }
}
</style>

<style lang="less" scoped>
.rule-icon {
  display: inline-block;
  min-width: 10px;
  padding: 1px;
  font-size: 12px;
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  border-radius: 2px;
  background-color: #f0773c;
  color: #fff;
}
.rule-icon-img {
  float: left;
  width: 9px;
  height: 12px;
  margin-top: 3px;
  margin-right: 5px;
}
.order-drop-price-dialog {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 9;
}
.drop-cancel-wrapper {
  overflow: hidden;
  padding-left: 50px;
  padding-right: 50px;
  .go-refund-title {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
  .go-refund-txt {
    margin-top: 16px;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    color: rgba(51, 51, 51, 1);
  }
  .cancel-text {
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
  .reduce-product-info {
    overflow: auto;
    max-height: 200px;
    margin-top: 16px;
    font-size: 14px;
    font-weight: 400;
    min-height: 80px;
    color: #333333;
    .reduce-product-item {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .ok-btn {
    margin-left: 132px;
    width: 140px;
    height: 40px;
    background: rgba(241, 50, 50, 1);
    border-radius: 2px;
    color: #fff;
    cursor: pointer;
    margin-bottom: 40px;
  }
  .cancel-footer-unnormal {
    text-align: center;
    margin-bottom: 20px;
    margin-top: 10px;
    bottom: 30px;
    left: 71px;
    .cancel-btn {
      width: 140px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(222, 222, 222, 1);
      color: rgba(51, 51, 51, 1);
      margin-right: 24px;
      cursor: pointer;
    }
    .confirm-btn {
      width: 140px;
      height: 40px;
      background: rgba(241, 50, 50, 1);
      border-radius: 2px;
      color: #fff;
      cursor: pointer;
      border: 1px solid transparent;
    }
  }
  .cancel-footer {
    text-align: center;
    margin-bottom: 10px;
    position: absolute;
    bottom: 30px;
    left: 71px;
    .cancel-btn {
      width: 140px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      border: 1px solid rgba(222, 222, 222, 1);
      color: rgba(51, 51, 51, 1);
      margin-right: 24px;
      cursor: pointer;
    }
    .confirm-btn {
      width: 140px;
      height: 40px;
      background: rgba(241, 50, 50, 1);
      border-radius: 2px;
      color: #fff;
      cursor: pointer;
      border: 1px solid transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/OrderDrop.vue